module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/label-new/label-new.component.css
// module id = ./src/app/admin/label-new/label-new.component.css
// module chunks = main